function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  fillRule: "nonzero",
  d: "M33.39 27.582c2.388-.64 4.888-2.545 7.502-5.716-3.85-1.44-6.967-1.84-9.354-1.2-3.58.96-4.123 2.764-3.612 4.674.512 1.91 1.884 3.2 5.465 2.242z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M40.048 22.092c-3.451-1.207-6.247-1.514-8.38-.943-2.953.791-3.787 2.091-3.259 4.062.528 1.97 1.9 2.679 4.852 1.888 2.134-.572 4.402-2.236 6.787-5.007z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  fillRule: "nonzero",
  d: "M30.232 15.174c-.948-2.032-3.044-3.966-6.29-5.802-.679 3.666-.545 6.515.403 8.548 1.421 3.048 3.12 3.248 4.745 2.49s2.563-2.188 1.142-5.236z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M24.313 10.165c-.52 3.233-.352 5.749.485 7.543 1.161 2.491 2.427 3.02 4.08 2.25 1.654-.772 2.062-2.081.9-4.572-.836-1.795-2.655-3.54-5.465-5.22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  fillRule: "nonzero",
  d: "M44 13.368A8.718 8.718 0 0041.5 13C34.044 13 28 22.626 28 34.5c0 .167.001.334.004.5h-2.99A37.397 37.397 0 0125 34c0-8.805 3.095-16.546 7.772-21H44v.368z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M37.298 13.5h-4.324C28.354 17.998 25.5 25.633 25.5 34c0 .167.001.334.003.5H27.5c0-9.834 4.09-18.199 9.798-21z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  fillRule: "nonzero",
  d: "M46.622 4.895l-1.765 3.647 2.877-1.152c.115 1.339-.489 2.793-1.802 4.6-2.988 4.113-8.594 6.164-11.916 3.75-3.323-2.414-3.105-8.379-.116-12.493C35.533 1 36.986-.036 38.7.018l-.843 3.184 3.61-2.328c.298.157.607.336.926.536L41.295 5.7l3.742-2.371c.643.538 1.171 1.055 1.585 1.566z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M46.03 4.97a11.17 11.17 0 00-1.037-1.021l-4.495 2.848 1.319-5.153c-.111-.066-.22-.13-.328-.19l-4.446 2.868L38.04.56c-1.232.203-2.388 1.129-3.734 2.981-2.937 4.042-2.968 9.634.005 11.794 2.972 2.16 8.281.402 11.218-3.64 1.03-1.417 1.574-2.56 1.694-3.561l-3.377 1.352 2.186-4.516z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  fillRule: "nonzero",
  d: "M13.105 32h27.049c.07.837.105 1.69.105 2.556C40.26 45.846 34.157 55 26.63 55 19.103 55 13 45.847 13 34.556c0-.866.036-1.719.105-2.556z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M13.57 32.5a30.45 30.45 0 00-.07 2.056c0 11.047 5.931 19.944 13.13 19.944 7.198 0 13.13-8.897 13.13-19.944 0-.69-.024-1.376-.07-2.056H13.57z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  fillRule: "nonzero",
  d: "M10 56h39v12H10z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M10.5 56.5h38v11h-38z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  fillRule: "nonzero",
  d: "M5 54h11l-5.843 78H5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M5.5 54.5v77h4.193l5.768-77z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  fillRule: "nonzero",
  d: "M52 54H42l4.751 78H52z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M51.5 54.5v77h-4.278l-4.691-77z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  fillRule: "nonzero",
  d: "M0 51h57v7H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M.5 51.5h56v6H.5z"
})));

function SvgRoomSceneryEndTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 132,
    viewBox: "0 0 57 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryEndTable);
export default __webpack_public_path__ + "static/media/RoomSceneryEndTable.6b379900.svg";
export { ForwardRef as ReactComponent };